/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

export const HERO_HOVER_SCALE = 1.035;
export const HERO_SLIDE_EDGE_OPACITY = 0.64;

export const getHeroSlideImageOpacity = ({
  containerWidth,
  index,
  scrollOffset,
}: {
  containerWidth: number;
  index: number;
  scrollOffset: number;
}) => {
  const slideProgress = containerWidth
    ? Math.abs(scrollOffset / containerWidth - index)
    : 0;

  return Math.max(
    HERO_SLIDE_EDGE_OPACITY,
    1 - Math.min(slideProgress, 1) * (1 - HERO_SLIDE_EDGE_OPACITY),
  );
};

export const getHeroBannerImageStyle = ({
  imageOpacity,
  isHovered,
}: {
  imageOpacity: number;
  isHovered: boolean;
}): React.CSSProperties => ({
  filter: isHovered ? 'saturate(1.04)' : 'saturate(1)',
  opacity: imageOpacity,
  transform: `scale(${isHovered ? HERO_HOVER_SCALE : 1})`,
  transformOrigin: 'center center',
  transition:
    'transform 360ms cubic-bezier(0.22, 1, 0.36, 1), filter 360ms cubic-bezier(0.22, 1, 0.36, 1), opacity 180ms linear',
  willChange: 'transform, filter, opacity',
});
